export const parseMediaFromCMS = (
  cmsMediaObject: any,
): {
  src: string;
  alt: string;
  height: number;
  width: number;
} => {
  const {
    url: src,
    alternativeText: alt,
    ...rest
  } = cmsMediaObject?.data?.attributes ?? {
    url: '',
    alternativeText: '',
  };
  return {
    src,
    alt,
    ...rest,
  };
};
